import React from 'react';

import { useNavigate } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';
import Modal from '@/components/ui/modals/Modal';
import { type ModalInnerProps } from '@/hooks/common/useModal';

import styles from './AbsencesCancelFormModal.module.scss';

interface Props extends ModalInnerProps {
  url: string;
}

const AbsencesCancelFormModal: React.FC<Props> = ({ isOpen, toggle, url }) => {
  const navigate = useNavigate();

  const onClick = React.useCallback(() => {
    navigate(url);
    toggle();
  }, [navigate, toggle, url]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} title={'本当にキャンセルしますか？'}>
      <div className={styles.description}>
        送信せずに戻ります。よろしいでしょうか？
      </div>
      <div className={styles.buttons}>
        <Button
          size="s"
          color="outline"
          onClick={toggle}
          className={styles.button}
        >
          いいえ
        </Button>
        <Button
          size="s"
          color="primary"
          onClick={onClick}
          className={styles.button}
        >
          はい
        </Button>
      </div>
    </Modal>
  );
};

export default AbsencesCancelFormModal;
